<template>
  <section class="mb-12 md:mb-14">
    <div class="container mx-auto max-w-[1200px] px-4">
      <h2 class="landing_h2 mb-6 text-center">
        <Translate translate-key="safe_and_legal.title" />
      </h2>
      <div
        class="w-full leading-relaxed prose prose-gray max-w-none prose-p:mb-3 prose-ul:my-3 prose-li:my-0.5 prose-a:text-success"
      >
        <Translate class="flex mb-2" translate-key="safe_and_legal.text_1" />
        <Translate class="flex mb-2" translate-key="safe_and_legal.text_2" />
        <Translate class="flex mb-2" translate-key="safe_and_legal.list" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
</script>
